import { forwardRef, ReactElement } from "react";
import { Button } from "@material-ui/core";

import { getModuleClassNames } from "../../utils/getModuleClassNames";
import { ButtonLoader } from "./ButtonLoader";

import styles from "./CustomButton.module.scss";

export enum IButtonWidth {
  small = "small",
  medium = "medium",
  large = "large",
}

export enum IButtonVariant {
  primary = "primary",
  info = "info",
  neutral = "neutral",
  important = "important",
  transparent = "transparent",
  textImportant = "textImportant",
}

interface ICustomButtonProps {
  startIcon?: ReactElement;
  text: string;
  variant?: IButtonVariant;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  showLoader?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  id?: string;
}

export const CustomButton = forwardRef<any, ICustomButtonProps>(
  (
    { startIcon, text, variant = IButtonVariant.primary, className, onClick, showLoader, disabled, fullWidth, id },
    ref
  ) => {
    const appliedButtonClassNamesArray = [styles.customButton, styles[variant]];
    if (className) {
      appliedButtonClassNamesArray.push(className);
    }

    return (
      <Button
        onClick={onClick}
        startIcon={startIcon}
        variant="text"
        className={getModuleClassNames(appliedButtonClassNamesArray)}
        disableElevation
        disabled={disabled}
        ref={ref}
        fullWidth={fullWidth}
        id={id}
      >
        {showLoader ? <ButtonLoader /> : text}
      </Button>
    );
  }
);
